<template>
    <b-modal
        id="modal_select_unidade"
        ref="modal_select_unidade"
        title="Selecione a unidade"
        ok-title="Transferir"
        close-title="Fechar"
        v-model="showModal"
        no-close-on-backdrop
        :ok-disabled="!unidadeSelecionada"
        @ok="onConfirmSelect"
    >
        <h4>
            Selecione a unidade para qual você deseja transferir as
            {{ notas.length }} notas:
        </h4>
        <multiselect
            v-model="unidadeSelecionada"
            :options="options"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione a unidade"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
        ></multiselect>
    </b-modal>
</template>

<script>
export default {
    mounted() {
        this.$events.$on(
            "open-modal-transferir-unidade",
            () => (this.showModal = true)
        );
    },
    props: {
        notas: {
            type: Array,
        },
        options: {
            type: Array,
        },
    },
    data() {
        return {
            unidadeSelecionada: null,
            showModal: false,
            transferirForm: new Form({
                docfis_ids: [],
                unidade_id: null,
            }),
        };
    },
    methods: {
        onConfirmSelect() {
            const unidade = this.unidadeSelecionada.value;
            this.$Simplert.open({
                title: "Tem certeza?",
                message: `Você deseja transferir as ${
                    this.notas.length
                } notas para a unidade ${unidade.cd} - ${
                    unidade.descr
                } (CNPJ ${this.onFormataCnpj(unidade.cnpj)} - ${
                    unidade.razao_social
                })? Essa ação não poderá ser desfeita.`,
                customConfirmBtnText: "Sim",
                customCloseBtnText: "Não",
                type: "warning",
                useConfirmBtn: true,
                onConfirm: () => {
                    this.onTransferir();
                },
                onClose: () => {
                    this.$Simplert.open({
                        title: "Ação cancelada",
                        message: "A transferência foi cancelada com sucesso.",
                        customCloseBtnText: "Fechar",
                        type: "info",
                    });
                },
            });
        },
        onTransferir() {
            this.transferirForm.docfis_ids = this.notas;
            this.transferirForm.unidade_id = this.unidadeSelecionada.value.unidade_id;
            this.transferirForm
                .patch("/api/gerarordemcoleta/transferirnotas")
                .then((response) => {
                    new ReturnApi(response, this);
                    this.$events.fire("filter-reset");
                })
                .catch((errors) => {
                    new ReturnApi(errors, this);
                });
            this.unidadeSelecionada = null;
        },
        onFormataCnpj(cnpj) {
            if (cnpj.length === 14) {
                return cnpj.replace(
                    /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
                    "$1.$2.$3/$4-$5"
                );
            } else {
                return cnpj;
            }
        },
    },
};
</script>
